import { useThemeContext } from '../context/ThemeContext';
export const useTheme = () => useThemeContext();
